var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPretoEstacio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.701,
    height: 33.73,
    viewBox: "0 0 136.701 33.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.007 -0.065)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.366 17.523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M981.171-6.014l-.294,7.284a1.273,1.273,0,0,0,.48-.3l6.514-6.515Z",
    transform: "translate(-980.876 15.003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.668-37.8l.433-7.021-7.408.3-.292,7.231Z",
    transform: "translate(-982.061 45.157)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.614-46.03l.428,6.649L1028.661-46a1.262,1.262,0,0,0,.228-.322Z",
    transform: "translate(-1012.53 46.323)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.007 0.065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M955.1-118.128l.262-6.483a1.272,1.272,0,0,0-.522.311l-5.75,5.75Z",
    transform: "translate(-938.822 124.611)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.715-76.854,903.4-71.541a1.275,1.275,0,0,0-.369.833l6.062-.244Z",
    transform: "translate(-903.033 87.503)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.529-90.9l-1,1-.468,7.573,8.971-.361.354-8.764Z",
    transform: "translate(-927.141 98.847)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M997.091-108.58l-15.652-15.652a1.275,1.275,0,0,0-.455-.291l.264,6.559,5.114.359-5.085.356.358,8.905,7.446.3.432-7,.454,7.038,7.5.3A1.277,1.277,0,0,0,997.091-108.58Z",
    transform: "translate(-963.594 124.608)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.659-37.154l6.484-.454-.286-7.13L910.84-45.1l-.333,5.389-.349-5.417-5.87-.237a1.285,1.285,0,0,0,.089.109L920.03-29.606a1.281,1.281,0,0,0,.447.288l-.3-7.378Z",
    transform: "translate(-904.001 63.103)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1101.648-91.9a7.433,7.433,0,0,0-5.661,5.815h0l-.111,5.915h0a7.382,7.382,0,0,0,5.772,6.5h0l8.968.181v-3.625h-7.368a3.685,3.685,0,0,1-3.478-3.816h10.846v-3.625H1099.77a3.685,3.685,0,0,1,3.478-3.816h7.368V-92l-8.968.1Z",
    transform: "translate(-1052.866 99.337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.231-63.745h-5.8v0a1.188,1.188,0,0,1-1.111-1.278,1.188,1.188,0,0,1,1.111-1.278h0l3.456.072h3.795V-68.9h-8.4c-1.877,0-3.3,2.092-3.3,4.09,0,1.647,1.009,3.61,2.419,3.733h5.653a1.3,1.3,0,0,1,1.112,1.241,1.344,1.344,0,0,1-1.112,1.278h0l-3.434-.038h-4.389v2.671h8.307a4.094,4.094,0,0,0,4.076-4.1C1184.616-61.666,1183.564-63.749,1182.231-63.745Z",
    transform: "translate(-1112.004 81.386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.623-92h-3.244v5.152h-2.671v2.671h2.671l.058,7.06h0a3.4,3.4,0,0,0,3.186,3.214h0l3.816.03v-2.671h-1.908v.016l-.077,0a1.882,1.882,0,0,1-1.831-1.381V-78.9c0-.062-.023-.124,0-.124h0v-5.152h3.816v-2.671h-3.816Z",
    transform: "translate(-1160.74 99.337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.936-68.9h-9.125v2.671h5.883l1.558-.072h0a1.336,1.336,0,0,1,.24-.019,1.3,1.3,0,0,1,1.324,1.27.361.361,0,0,1-.038.158h0v1.145h-6.3v.025c-1.908.037-3.434,1.181-3.434,2.59v2.594c0,1.409,1.526,2.553,3.434,2.59v.025h9.54v-10.4A2.809,2.809,0,0,0,1295.936-68.9Zm-.157,10.3h-4.752l-.4.038h0a.337.337,0,0,1-.213-.054s0,0,0,0a1.276,1.276,0,0,1-.183-.082c-.022-.012-.04-.026-.061-.038a1.236,1.236,0,0,1-.117-.078c-.022-.017-.043-.036-.063-.055a1.249,1.249,0,0,1-.093-.089c-.02-.021-.039-.044-.057-.066s-.052-.067-.075-.1-.032-.049-.046-.074a1.277,1.277,0,0,1-.058-.118c-.012-.026-.023-.052-.033-.078a1.344,1.344,0,0,1-.04-.141c-.005-.024-.014-.047-.017-.071a1.254,1.254,0,0,1-.021-.225,1.25,1.25,0,0,1,.021-.225c0-.024.012-.048.017-.071a1.261,1.261,0,0,1,.04-.141c.01-.027.022-.052.033-.078a1.144,1.144,0,0,1,.058-.118c.015-.025.03-.05.046-.074s.049-.07.075-.1.037-.045.058-.066a1.185,1.185,0,0,1,.093-.09c.021-.018.042-.037.064-.054a1.257,1.257,0,0,1,.117-.078c.021-.013.041-.027.062-.038a1.3,1.3,0,0,1,.188-.082s-.008,0,0,0c.073-.024.022-.005.213-.017h5.152Z",
    transform: "translate(-1200.631 81.386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.982-92H1310.6l-2.223,3.244h1.852Z",
    transform: "translate(-1217.982 99.337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1365.543-66.241h4.01a.582.582,0,0,1,0-.327v-2.344H1364.4v0a6.361,6.361,0,0,0-6.245,6.49,6.464,6.464,0,0,0,6.3,6.49h5.1v-2.379c0-.076-.057-.1,0-.289l-4.01.044h0a3.861,3.861,0,0,1-3.7-3.881A3.789,3.789,0,0,1,1365.543-66.241Z",
    transform: "translate(-1256.657 81.401)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.816,
    height: 3.244,
    transform: "translate(116.137 7.337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.816,
    height: 12.975,
    transform: "translate(116.137 12.489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.444-68.958a6.677,6.677,0,0,0-6.854,6.484,6.677,6.677,0,0,0,6.854,6.484,6.677,6.677,0,0,0,6.854-6.484A6.677,6.677,0,0,0,1461.444-68.958Zm-.185,10.374a3.645,3.645,0,0,1-3.334-3.89,3.645,3.645,0,0,1,3.334-3.89,3.645,3.645,0,0,1,3.335,3.89A3.645,3.645,0,0,1,1461.258-58.584Z",
    transform: "translate(-1331.589 81.434)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPretoEstacio);
export default __webpack_public_path__ + "static/media/logo-preto-estacio.dbd8827967623c29833de102eef8ad60.svg";
export { ForwardRef as ReactComponent };